import React from "react";
import {
  // HiXCircle,
  AiOutlineBorderOuter,
  // MdSkipPrevious,
  // MdExitToApp
} from "react-icons/ai";
import { useTranslation } from "react-i18next";

export default function AddOuterMarginButton(props) {
  const { t } = useTranslation();
  return (
    <>
      <button
        // disabled={props.isLoading}
        className={`button  is-small modal-button ${
          props.disabled ? "button-disabled" : ""
        } ${
          props.shouldShowButtonLabels ? " show-label-top-menu " : ""
          }`}
        onClick={props.onClickHandler}
        title={t("Add Margin")}
      >
        <span className="icon icon-tema-color is-small has-text-light">
          <AiOutlineBorderOuter className="fas fa-2x" />
        </span>
        {props.shouldShowButtonLabels && <span className=" mr-1 show-label-text">{t("Add Margin")}</span>}
      </button>
    </>
  );
}
